import Col from "../../../components/element/col";
import { useTranslation } from "react-i18next";
import Container from "../../../components/element/container";
import Icon from "../../../components/element/icon";

import Row from "../../../components/element/row";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import { HomeBanner, MobileHomeBanner } from "../../../assets/images";
import Image from "../../../components/element/image";

export default function HomeNews() {
  const { t } = useTranslation();
  const { isDesktop } = useWindowDimension();

  return (
    <Container className="home-news">
      <Row className="_row news-heading-row items-center gap-50">
        <Icon icon="boxicons:announcement" className="_svg news" />
        <p className="_label news-title">{t("What News")}</p>
      </Row>
      <Col
        className="_col news-card w-100"
        // style={{
        //   backgroundImage: !isDesktop ? `url(${MobileHomeBanner})` : "",
        // }}
      >
        <Image src={isDesktop ? HomeBanner : MobileHomeBanner} />

      </Col>
    </Container>
  );
}
